module.exports = __webpack_public_path__ + "img/404.600d9ab4.png";